'use client';

import { ThemeProvider, Theme } from '@mui/material/styles';
import { RuntimeConfiguration } from '@/configuration';
import { WalletOptionsProps } from '../components/ConnectExistingWallet';
import {
  AuthenticationProvider,
  WalletDetailsProvider,
  AppKitModalProvider,
  ModalStateProvider,
  WalletOptionsProvider,
  PaymentDetailsProvider,
  PaymentProvider,
  SelectedCollectionProvider,
  CollectionListProvider,
  AccessTokenProvider,
  SelectedCollectionDetailsProvider
} from '../providers';
import MetaMaskProvider from '../providers/MetaMaskWalletProvider';
import { createAppKit } from '@reown/appkit/react';
import { Ethers5Adapter } from '@reown/appkit-adapter-ethers5';
import { mainnet, sepolia } from '../utils/getReOwnChains';
import { ChainName } from '../interface';
export interface ApolloClientOptions {
  uri?: string;
  token?: string;
}
export interface ClaimManagementProviderProps {
  children: JSX.Element | JSX.Element[];
  theme: Theme;
  activeChain: ChainName;
  clientId: string;
  walletOption?: WalletOptionsProps;
  onAuthenticated: (token: string) => void;
}

export const projectId = RuntimeConfiguration.WALLET_CONNECT_PROJECT_ID!;

createAppKit({
  projectId,
  adapters: [new Ethers5Adapter()],
  metadata: {
    name: 'Kinetek',
    description: 'Explore Kinetek: Where Art Meets Technology',
    url: RuntimeConfiguration.BASE_URL,
    icons: ['https://res.cloudinary.com/duwztsuxj/image/upload/v1702977949/Frame_237686_o3kx24.svg']
  },
  networks: [mainnet, sepolia],
  features: {
    email: false,
    socials: false,
    emailShowWallets: false
  }
});

const ClaimManagementProvider = ({ children, theme, walletOption, onAuthenticated }: ClaimManagementProviderProps) => {
  return (
    <ThemeProvider theme={theme}>
      <AuthenticationProvider onAuthenticated={onAuthenticated}>
        <AppKitModalProvider>
          <MetaMaskProvider>
            <WalletOptionsProvider walletOption={walletOption}>
              <WalletDetailsProvider>
                <ModalStateProvider>
                  <CollectionListProvider>
                    <SelectedCollectionDetailsProvider>
                      <SelectedCollectionProvider>
                        <PaymentDetailsProvider>
                          <PaymentProvider>
                            <AccessTokenProvider>{children}</AccessTokenProvider>
                          </PaymentProvider>
                        </PaymentDetailsProvider>
                      </SelectedCollectionProvider>
                    </SelectedCollectionDetailsProvider>
                  </CollectionListProvider>
                </ModalStateProvider>
              </WalletDetailsProvider>
            </WalletOptionsProvider>
          </MetaMaskProvider>
        </AppKitModalProvider>
      </AuthenticationProvider>
    </ThemeProvider>
  );
};

export default ClaimManagementProvider;
